<div *ngFor="let img of carouselVM.images; index as i" class="carousel-preview-container" [ngClass]="{ 'photo': isDefectDetailsView(carouselVM.layout) }" (click)="showImage(i)">
  <app-image-preview-item
    [class]="carouselVM.classList"
    [photoPath]="img.path"
    [size]="img.size"
    [viewerWidth]="carouselVM.viewerWidth ?? '800px'"
    [viewerHeight]="carouselVM.viewerHeight ?? '600px'"
    [viewerLayout]="carouselVM.layout"
    [viewerFileName]="img.fileName"
    [viewerAuthorName]="carouselVM.authorName"
    [viewerDownloadEstateId]="img.download?.estateId"
    [viewerPanelClass]="carouselVM.viewerPanelClass"
    [isCarousel]="isCarousel"
    [removeButton]="!isRemoving"
    (onRemove)="removeImage(i)"
  ></app-image-preview-item>
</div>
